import React from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const TabComponent = ({ activeTab, handleTabSelect, tabs }) => {
  return (
    <Tabs
      defaultActiveKey={tabs[0].eventKey}
      id="transaction-tabs"
      activeKey={activeTab}
      onSelect={handleTabSelect}
      className="tab1"
    >
      {tabs.map((tab) => (
        <Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}>
          <div className="table-container">
            <div className="table-inner-container">{tab.content}</div>
          </div>
        </Tab>
      ))}
    </Tabs>
  );
};

export default TabComponent;
